export default __webpack_public_path__ + "static/media/qr-pdf-template.f76a723c.png";